import { FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { useCustomHook } from "../../../../../../GlobalFunctions/globalFunctions";
import DropdownIcon from "../../../../../components/DropdownIcon/DropdownIcon";
import { useSelector } from "react-redux";

export default function Status({ data, setInputValue, formik, addGroupData }) {
  const { studentStatusList: dataList } = useCustomHook();
  const inputValue =
    dataList?.find((item) => item.key === data.status)?.name || "";
  const [openDropdown, setOpenDropdown] = useState(false);
  const { user } = useSelector((state) => state.user);
  const [userPower, setUserPower] = useState(null);

  const addData = (value) => {
    addGroupData("status", value);
    setInputValue("status", value);
    setOpenDropdown(false);
  };

  useEffect(() => {
    if (user?.role === "worker") {
      const power =
        user.profiles?.find((item) => item.profile === "students")?.power ||
        null;
      setUserPower(power);
    } else if (user?.role === "super-admin") {
      setUserPower("all");
    }
  }, [user]);
  return (
    <>
      <div className="class-input">
        <div className="dropdown-input">
          <div className="input-box">
            <TextField
              sx={{
                "& input": {
                  fontSize: "12px",
                  marginRight: "32px",
                },
                marginTop: "24px",
              }}
              InputLabelProps={{
                style: { fontSize: "12px", color: "#3F3F3F" },
              }}
              fullWidth
              label="Status"
              autoComplete="off"
              disabled={userPower !== "all"}
              value={inputValue}
              onBlur={() => formik.setFieldTouched("salesType", true)}
              required={true}
            />
            {userPower === "all" && (
              <DropdownIcon
                setOpenDropdown={setOpenDropdown}
                openDropdown={openDropdown}
              />
            )}
          </div>

          <ul
            className={`dropdown-body where-coming ${
              openDropdown ? "active" : ""
            }`}
          >
            {dataList?.map((item) => (
              <li key={item.key} onClick={() => addData(item.key)}>
                <h4>{item.name}</h4>
              </li>
            ))}
          </ul>
        </div>
      </div>
      {formik.errors.salesType && formik.touched.salesType && (
        <small className="validation-err-message">
          {formik.errors.salesType}
        </small>
      )}
    </>
  );
}
